module.exports = __webpack_public_path__ + "img/coin3.93f6723.webp";